export default {
  export: 'ส่งออก',
  cancel: 'ยกเลิก',
  back: 'ย้อนกลับ',
  try: 'ลองอีกครั้ง',
  download_success: 'ดาวน์โหลดสำเร็จ',
  download_failed: 'ดาวน์โหลดไม่สำเร็จ',
  downloading: 'กำลังดาวน์โหลด',

  modal_warning: {
    title: 'ยืนยัน',
    desc: 'Expire Data หมดอายุ ต้องการโหลดใหม่อีกครั้ง',
    cancel: 'ยกเลิก',

  },
};
